<template>
    <div class="wrapper" v-loading="loading">
        <span @click="back" class="back-btn"><i class="el-icon el-icon-arrow-left"></i></span>

        <div v-show="!choose">
            <el-row style="margin: 30px 0; text-align: center">
                <label class="page-label">ご予約日の変更</label>
                <p style="margin: 0; font-size: 20px">新しい予約日を選択してください。人数の変更はできません。</p>
            </el-row>

            <div style="text-align: center;margin-bottom: 40px;">
                <img :src="imageUrl" class="image"/>
            </div>

            <div class="color-description">
                <div>
                    <div style="background: #999"/>
                    <span>{{$t('homePage.full')}}</span>
                </div>
                <div>
                    <div style="background: #1c6ca1"/>
                    <span>{{$t('homePage.bookable')}}</span>
                </div>
                <div>
                    <div style="background-color: #D58400"></div>
                    <span> 当日(予約不可)</span>
                </div>
            </div>
            <BookingCalendar ref="calendar" @chooseTimeRange="chooseTimeRange"/>
        </div>
        <ChangeBookingDateConfirm ref="confirmDialog" @back="closeDialog(true)"/>
    </div>
</template>

<script>

    import FacilityApi from "../../api/facility/FacilityApi";
    import Pages from "../../router/Pages";
    import BookingApi from "../../api/booking/BookingApi";
    import BookingConfirmApi from "../../api/bookingConfirm/BookingConfirmApi";
    import AlertService from "../../service/alert.service";
    import ChangeBookingDateConfirm from "./ChangeBookingDateConfirm";

    export default {
        name: "ChangeBookingDate",
        components: {ChangeBookingDateConfirm},
        mounted() {
            let bookingCode = this.$route.query.bookingCode;
            this.bookingCode = bookingCode;
            let facilityCode = this.$route.query.facilityCode;
            this.facilityCode = facilityCode;
            if (bookingCode) {
                BookingConfirmApi.detail(bookingCode).then(res => this.booking = res);
            }

            if (facilityCode) {
                this.$refs.calendar.reload(facilityCode);
                FacilityApi.getLogoUrl(facilityCode)
                    .then(url => this.imageUrl = url);
            }
        },
        data() {
            return {
                imageUrl: "",
                booking: {},
                facilityCode: '',
                bookingCode: '',
                choose: false,
                loading: false
            }
        },
        methods: {
            closeDialog(fromDialog) {
                if (!fromDialog) this.$refs.confirmDialog.back();
                this.choose = false;
            },
            back() {
                if (this.choose) {
                    this.closeDialog();
                    return;
                }
                this.$router.push({path: Pages.home.path});
            },
            async chooseTimeRange(timeRange) {
                const vue = this;
                function alert() {
                    vue.loading = false;
                    AlertService.error("その枠は選択できません。");
                }
                this.loading = true;
                const haveSlot = timeRange.availableSlot >= this.booking.totalBookedSlot;
                if (!haveSlot) {
                    console.log("don't have slot");
                    alert();
                    return;
                }

                const timeRangeSlots = await BookingApi.getByBookingTimeRange(timeRange.code);
                const matchSlot = this.verifyChangeSlots(timeRangeSlots);
                if (!matchSlot) {
                    console.log("not match slot");
                    alert();
                    return;
                }
                this.loading = false;
                this.choose = true;
                this.$refs.confirmDialog.load(this.booking, timeRange)
            },
            verifyChangeSlots(slots) {
                for (let bookedSlot of this.booking.bookedSlotTypes) {
                    let found = slots.some(s => s.name == bookedSlot.slotType.name && s.pricePerSlot == bookedSlot.slotType.pricePerSlot);
                    if (!found)
                        return false;
                }
                return true;
            }
        },
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 770px) {
        .back-btn {
            left: -30px !important;
        }
        .image {
            width: auto !important;
            max-width: 60% !important;
            height: 25vw !important;
            margin: 30px 0 !important;
        }
    }

    @media screen and (min-width: 770px) and (max-width: 1000px) {
        .wrapper {
            width: 100% !important;
        }

        .page-label {
            font-size: 30px;
            position: relative;
            display: inline-block;
            width: calc(80% - 50px);
            margin: 0 calc(10% + 25px);
        }
        .back-btn {
            left: 10%;
        }
    }

    .wrapper {
        width: 90%;
        margin: auto;
        position: relative;
    }

    .image {
        width: 30%;
        margin: 0 35%;
    }

    .color-description {
        > div {
            display: inline-block;

            > div {
                display: inline-block;
                width: 80px;
                height: 25px;
            }

            > span {
                display: inline-block;
                height: 25px;
                position: relative;
                top: -6px;
                margin: 0 15px 0 7px;
            }
        }
    }

    .back-btn {
        position: absolute;
        cursor: pointer;
        font-size: 40px;
        font-weight: bold;
        z-index: 1;
        left: 0;

        &:hover {
            color: #2b3b4e;
        }

        &:active {
            color: #455664;
        }
    }

    .page-label {
        white-space: nowrap;
        font-weight: bold;
        font-size: 40px;
    }
</style>